<template>
    <div class="header-nav">
        <!-- 顶部导航 -->
        <div class="index-nav">
            <div :class="['index-nav-group', {'animated':!isMobile,'lightSpeedIn':!isMobile}]">
                <div :class="['index-nav-item', 'active']">
                    <!-- <router-link to="/">{{$t("home")}}</router-link> -->
                    <a @click="handleScrollTo('index')">{{$t("home")}}</a>
                </div>
                <div v-if="isMobile" class="index-nav-item">|</div>
                <div :class="['index-nav-item']">
                    <a @click="handleScrollTo('video')">{{$t("video")}}</a>
                </div>
                <div v-if="isMobile" class="index-nav-item">|</div>
                <div :class="['index-nav-item']">
                    <a @click="handleScrollTo('generals')">{{$t("role")}}</a>
                </div>
                <div v-if="isMobile" class="index-nav-item">|</div>
                <div :class="['index-nav-item']">
                    <a @click="handleScrollTo('strategicmap')">{{$t("map")}}</a>
                </div>
                <div v-if="isMobile" class="index-nav-item">|</div>
                <div :class="['index-nav-item']">
                    <a @click="handleScrollTo('description')">{{$t("summary")}}</a>
                </div>
                <div v-if="isMobile" class="index-nav-item">|</div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    props: {
        isMobile: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isMove: false,
            news: true // 有新的公告
        };
    },
    computed: {},
    watch: {},
    mounted() {
        let that = this,
            rotate = 0;
        //点击顶部导航条
        $(".index-nav-group .index-nav-item").on("click", function() {
            $(".index-nav-group .index-nav-item").removeClass("active");
            $(this).addClass("active");
            if (this.isMobile) {
                return;
            }
            // 旋转挂件 - 国内版去掉挂件
            return;
            rotate = rotate ? (rotate += 360) : (rotate -= 360);
            $(".download-pendant").css({
                transform: `rotateY(${rotate}deg)`
            });
        });

        if (document.body.offsetWidth > 768) {
            //页面滚动时顶部导航条切换
            $("#main").scroll(function() {
                //判断是否在滚动，如果没有，则支执行这里的代码
                if (!that.isMove) {
                    //获取滚动距离
                    let _scrollTop = $("#main").scrollTop();
                    // 5个菜单按钮
                    let i = Math.round(_scrollTop / document.body.offsetHeight);
                    i = i > 4 ? 4 : i;
                    $(`.index-nav-group .index-nav-item`).removeClass("active");
                    $(`.index-nav-group .index-nav-item:nth(${i})`).addClass(
                        "active"
                    );
                }
            });
        }
    },
    methods: {
        handleScrollTo(elemId) {
            let h = document.getElementById(elemId).offsetTop;
            if (this.isMobile) {
                h -= 100;
                document.getElementById("main").scrollTo({
                    top: h,
                    behavior: "smooth"
                });
            } else {
                document.getElementById("main").scrollTo({
                    top: h,
                    behavior: "smooth"
                });
            }
        },
        // 阻止事件传播
        stopFunc(e) {
            e.stopPropagation ? e.stopPropagation() : (e.cancelBubble = true);
        }
    }
};
</script>

<style lang="scss">
@keyframes active_news {
    0% {
        background: url("~@assets/imgs/tip-news-normal.png") center no-repeat;
        background-size: 150%;
    }
    50% {
        background: url("~@assets/imgs/tip-news-light.png") center no-repeat;
        background-size: 150%;
    }
    100% {
        background: url("~@assets/imgs/tip-news-normal.png") center no-repeat;
        background-size: 150%;
    }
}
.header-nav {
    position: fixed;
    top: 0;
    z-index: 1000;
    width: 100%;
    .index-nav {
        background: url("~@assets/imgs/header-bg.png") center top no-repeat;
        background-size: 100% 100%;
        padding: 0 20px;
        .index-nav-group {
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            transition: all 0.2s linear;
            .index-nav-item {
                height: 70px;
                line-height: 60px;
                margin: 0 3%;
                text-align: center;
                a {
                    color: #fff;
                    display: block;
                    height: 100%;
                    font-size: 22px;
                    font-weight: 400;
                }
                .btn-new {
                    width: 140px;
                    height: 65px;
                    position: relative;
                    background: url("~@assets/imgs/btn-new.png") center
                        no-repeat;
                    background-size: 140px;
                    span {
                        display: block;
                        width: 40px;
                        height: 40px;
                        position: absolute;
                        right: -10px;
                        top: 2px;
                        background: url("~@assets/imgs/tip-news-light.png")
                            center no-repeat;
                        background-size: 100%;
                        animation: "active_news" 0.8s linear infinite;
                    }
                }
            }
            .active a,
            a:hover {
                color: #f8da6c;
            }
            .index-nav-item.form {
                position: absolute;
                right: 10px;
                top: 7%;
                margin: 0;
            }
        }
    }
    .download-box {
        position: absolute;
        top: 100%;
        right: 120px;
        perspective: 2000px;
        width: 55px;
        height: 200px;
        z-index: 100;
        .download-pendant {
            position: absolute;
            top: 0;
            right: 0;
            background: url("~@assets/imgs/right-top-pendant.png") no-repeat
                center top;
            background-size: 100%;
            width: 55px;
            height: 200px;
            transition: all 1s linear;
            transform: rotateY(0deg);
            a {
                display: block;
                height: 50px;
                cursor: pointer;
            }
            .btn-pendant {
                margin-top: 26px;
            }
            .btn-bird {
                margin-top: 15px;
            }
        }
    }
}
// 移动端
@media screen and (max-width: 768px) {
    .header-nav {
        .index-nav {
            height: 50px;
            padding: 0 20px;
            .index-nav-group {
                height: 50px;
                overflow: hidden;
                justify-content: space-around;
                .index-nav-item {
                    height: 45px;
                    line-height: 45px;
                    margin: 0;
                    a {
                        font-size: 16px;
                    }
                    .btn-new {
                        width: 100px;
                        height: 30px;
                        top: 8px;
                        background-size: 80px;
                        span {
                            width: 25px;
                            height: 25px;
                            right: 13px;
                            top: 2px;
                        }
                    }
                }
            }
        }
        .download-box {
            display: none;
        }
    }
}
@media screen and (max-width: 500px) {
    .header-nav {
        .index-nav {
            .index-nav-group {
                padding: 0 10px;
                .index-nav-item {
                    a {
                        font-size: 14px;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/HeaderNav.vue